import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { HttpApiService } from '../services/http-api.service';
import { PageModel } from '../utils/interfaces/page-model';
import { Pagination } from '../utils/interfaces/pagination';

@Injectable({
  providedIn: 'root',
})
export class GamesService {
  constructor(private http: HttpApiService, private ngFb: FormBuilder) {}

  getGamesCallback() {
    return this.http.get<any[]>(`v2/ag/game/callback`);
  }

  getGamesByCurrencyForFilter(currency: string) {
    return this.http.get<gameCodeFilter[]>(
      `v2/ag/game/get-game/by-currency/filter?currency=${currency}`
    );
  }

  getGamesCompanyPercentage() {
    return this.http.get<any[]>(`v2/ag/games-company`);
  }
  getGamesProvider() {
    return this.http.get<GameProvider[]>(`v2/ag/game-provider`);
  }
  getGamesConnected() {
    return this.http.get<any>(`v2/ag/game-connected`);
  }

  getSyncGameProvider() {
    return this.http.post<any>(`v2/ag/game-provider-sync`, {});
  }

  getTypeGames() {
    return this.http.get<{ id: string }[]>(`api/ask4bet/game/type`);
  }

  changeStatusGame(game_id: string, status: string) {
    return this.http.get(`v2/ag/game/change-status?game_id=${game_id}&status=${status}`);
  }
  gameTestLogin(params: any) {
    return this.http.post<any>(`v2/ag/game/not-save/login`, {}, { params });
  }
  gameListTestLogin(params: any) {
    return this.http.post<GmaeListLoginTest>(`v2/ag/game-list-all/check`, {}, { params });
  }

  getGames(params: any) {
    return this.http.get<Pagination<Game[]>>(`v2/ag/game/pagination`, { params });
  }
  editPercentageGameByCurrency(value: percentageEdit) {
    return this.http.post<any>(`v2/ag/game-edit-percentage`, value);
  }
  getGamesSyncPercentage() {
    return this.http.get<any>(`v2/ag/game-sync-percentage`);
  }
  getGamesTypeCount() {
    return this.http.get<any>(`v2/ag/game-type/count`);
  }
  getGamePreloadCreate(gameProvider: string, gameCode: string) {
    return this.http.get<Game>(
      `v2/ag/game-preload-create?game_provider=${gameProvider}&game_code=${gameCode}`
    );
  }

  getGame(gameProvider: string, gameCode: string) {
    return this.http.get<Game>(`v2/ag/game?game_provider=${gameProvider}&game_code=${gameCode}`);
  }

  getGameSubList(gameProvider: string, gameCode: string, status: string = '') {
    return this.http.get<SyncSubGame[]>(
      `v2/ag/game/list?game_provider=${gameProvider}&game_code=${gameCode}&status=${status}`
    );
  }

  getGameSubListSync(gameProvider: string, gameCode: string) {
    return this.http.put<SyncSubGame[]>(
      `v2/ag/game/list/sync?game_provider=${gameProvider}&game_code=${gameCode}`,
      {}
    );
  }
  getGameSubListSyncImage(gameProvider: string, gameCode: string) {
    return this.http.put<SyncSubGame[]>(
      `v2/ag/game/list/sync-image?game_provider=${gameProvider}&game_code=${gameCode}`,
      {}
    );
  }
  getGameSubListSyncImageToMain(gameProvider: string, gameCode: string) {
    return this.http.put<any>(
      `v2/ag/game/list/sync-image-to-main?game_provider=${gameProvider}&game_code=${gameCode}`,
      {}
    );
  }

  getGameSubListWinRate(gameProvider: string, gameCode: string) {
    return this.http.put<boolean>(
      `v2/ag/game/list/win-rate?game_provider=${gameProvider}&game_code=${gameCode}`,
      {}
    );
  }
  clearGameList(game_code: string) {
    return this.http.delete<boolean>(`v2/ag/clear-game-list?game_code=${game_code}`);
  }
  getAllGame(type = '') {
    return this.http.get<Game[]>(`api/ask4bet/game/list?type=${type}`);
  }

  create(value) {
    return this.http.post(`v2/ag/game`, value);
  }

  edit(value, id) {
    return this.http.put(`v2/ag/game?game_id=${id}`, value);
  }
  gamePivority(game_id: string, pivority: number) {
    return this.http.put<any>(`v2/ag/pivority/edit?game_id=${game_id}&pivority=${pivority}`, {});
  }

  gameListCreate(value) {
    return this.http.post(`v2/ag/game/list`, value);
  }

  gameListEdit(value, id) {
    return this.http.put(`v2/ag/game/list?game_list_id=${id}`, value);
  }
  gameListDelete(id) {
    return this.http.delete(`v2/ag/game/list?game_list_id=${id}`);
  }

  delete(id) {
    return this.http.delete(`v2/ag/game?game_id=${id}`);
  }

  /**
   * Get Game Demo Pagination
   * @param params PageModel, ?status={status}
   * @returns Observeable
   */
  getDemoPagination(params: PageModel = {}) {
    return this.http.get<Pagination<GameDemo[]>>(`api/ask4bet/game_demo`, { params });
  }

  postDemo(model: GameDemoModel) {
    return this.http.post(`api/ask4bet/game_demo`, model);
  }

  putDemo(id: number, model: GameDemoModel) {
    return this.http.put(`api/ask4bet/game_demo/${id}`, model);
  }

  deleteDemo(id: number) {
    return this.http.delete(`api/ask4bet/game_demo/${id}`);
  }

  get createFormGameDemo(): FormGroup<GameDemoModel> {
    return this.ngFb.group({
      game_id: [null],
      game_demo_image: [''],
      game_demo_name: [''],
      game_demo_url: [''],
      status: ['active'],
    });
  }

  getAgentGames(agent_id: number) {
    return this.http.get(`api/ask4bet/agent_game?agent_id=${agent_id}`);
  }

  putReorder(agent_id: number, model: GameOrder[]) {
    return this.http.put(`api/ask4bet/agent_game/order?agent_id=${agent_id}`, model);
  }
}
export interface percentageEdit {
  provider: string;
  game_code: string;
  currency: string;
  percent_system: number;
  percent_api: number;
  supported: boolean;
}
export interface Game {
  game_id: string;
  game_code: string;
  game_product_id: string;
  game_name: string;
  game_image: string;
  game_image_preview: string;
  game_provider: string;
  game_url_type: string;
  game_url: string;
  game_type: GameTypes;
  has_list: boolean;
  is_game_normal: boolean;
  status: string;
  create_dt: string;
  update_dt: string;
  update_by: number;
  game_order?: number;
  [key: string]: any;
  game_list_count: number;
  percentages: GamePercentageInGame[];
}
export interface GamePercentageInGame {
  game_provider: string;
  game_code: string;
  game_currency: string;
  game_percent_systems: number;
  game_percent_api: number;
  game_supported: boolean;
}
export interface GamePercentage {
  currency: string;
  game_percent_systems: number;
  game_percent_api: number;
  game_supported: boolean;
}
export interface GameOrder {
  game_id: number;
  game_order: number;
}
export interface GameProvider {
  game_provider: string;
}

export interface Response<T> {
  code: number;
  message: string;
  data: T;
}
export interface SyncSubGame {
  game_list_id: string;
  game_provider: string;
  game_code: string;
  game_list_code: string;
  game_category: string;
  game_name: string;
  game_image: string;
  game_image_preview: string;
  game_type: string;
  game_status: string;
  game_sort_priority: number;
  game_win_rate: number;
  new_update: boolean;
  create_dt: string;
  update_dt: string;
}

export enum GameType {
  casino = 'คาสิโน',
  keno = 'Keno',
  lotto = 'หวย',
  poker = 'โป๊กเกอร์',
  slot = 'สล็อต',
  sport = 'กีฬา',
  esports = 'E-Sports',
  cockfight = 'Cockfight',
  game_card = 'Game Card',
  trading = 'Trading',
}

export type GameTypes = keyof typeof GameType;

export interface GameDemoModel {
  game_id: number;
  game_demo_name: string;
  game_demo_url: string;
  game_demo_image: string;
  status: GameStatusTypes;
}

export type GameStatusTypes = 'active' | 'deative';

export interface GmaeListLoginTest {
  deactive_game: number;
  active_game: number;
  error: string[];
}

export interface GameDemo {
  id: number;
  game_id: number;
  game_provider: string;
  game_code: string;
  game_type: string;
  game_name: string;
  game_image: string;
  game_image_preview: string;
  game_demo_name: string;
  game_demo_url: string;
  game_demo_image: string;
  status: string;
  created_at: string;
  updated_at: string;
  updated_by: number;
}

export interface GameConnected {
  Id: number;
  Provider: string;
  GameCode: string;
  hasList: boolean;
  GameName: string;
  GameLogo: string;
  GameImageCover: string;
  GameType: string;
  PercentSystems: number;
  gpId: number;
  PercentAPI: number;
  Connected: boolean;
  game_id?: string;
  game_provider?: string;
  game_code?: string;
  game_product_id?: string;
  game_name?: string;
  game_image?: string;
  game_image_preview?: string;
  game_url_type?: string;
  game_url?: string;
  game_type?: string;
  game_tag: any;
  game_seamless?: boolean;
  has_list?: boolean;
  recommend?: boolean;
  popular?: boolean;
  game_sort_pivority?: number;
  status?: string;
  create_dt?: string;
  update_dt?: string;
}
export interface gameCodeFilter {
  game_type: string;
  game_name: string;
  game_code: string;
  checked: boolean;
}
